
<div :data-component-name="$options.name">
  <div class="w-100 h-100 div_general">
    <b-row class="w-100 h-100 d-flex align-items-center">
      <b-col class="col-12 col-md-4">
        <div v-if="content.petiteNote" class="boite_petite_note">
          <span class="petite_note" v-html="content.petiteNote"> </span>
        </div>
        <div v-if="content.surTitre" v-html="content.surTitre"></div>
        <div class="d-flex justify-content-center">
          <img
            v-lazy="jel_getFichierSrc(content.image)"
            class="w-100 h-100 drop-shadow"
            :alt="content.titre"
          />
        </div>
      </b-col>
      <b-col class="d-flex flex-column align-items-start col-12 col-md-8">
        <div>
          <h3 class="titre graphik_bold" v-html="content.titre"></h3>
        </div>
        <div class="sousTitre" v-html="content.sousTitre"></div>
        <div class="promo_texte" v-html="content.texte"></div>
        <div class="d-flex w-100 justify-content-center justify-content-md-start">
          <b-link v-if="content.lien" v-bind="jel_getLienBinding(content.lien)">
            <button
              class="btn graphik_bold btn_bingo_theme disableThemeHover"
              :style="[
                { 'background-color': content.colorBtn },
                { 'border-color': content.borderColor },
              ]"
            >
              {{ content.texteBouton }}
            </button>
          </b-link>
        </div>
      </b-col>
    </b-row>
  </div>
</div>
